module.exports = __webpack_public_path__ + "static/media/checkbox.0536d230.png";